import { InputHTMLAttributes, forwardRef } from 'react';
import { InputContainer, NumberContainer, StyledInput } from './NumberedInput.styles';

export interface NumberedInputProps extends InputHTMLAttributes<HTMLInputElement> {
  number: number;
  isActive?: boolean;
  onActivate?: () => void;
  displayOnly?: boolean;
  placeholder: string;
}

const NumberedInput = forwardRef<HTMLInputElement, NumberedInputProps>((
  {
    number,
    isActive = false,
    onActivate,
    displayOnly = false,
    placeholder,
    ...inputProps
  },
  ref
) => {
  const handleContainerClick = () => {
    if (onActivate && !displayOnly) {
      onActivate();
    }
  };

  return (
    <InputContainer $isActive={isActive} onClick={handleContainerClick} $displayOnly={displayOnly}>
      <NumberContainer $isActive={isActive} $displayOnly={displayOnly}>
        {number}
      </NumberContainer>
      <StyledInput
        placeholder={placeholder}
        disabled={displayOnly}
        $disabled={displayOnly}
        ref={ref}
        {...inputProps}
      />
    </InputContainer>
  );
});

export default NumberedInput;
